import { Injectable } from '@angular/core';
import { EvidenceCredentials } from './evidence-credentials.model';
import { CompanyContext } from 'src/app/common/ui/company-context-select/models/company-context.model';
import { CompanyContextState } from 'src/app/common/ui/company-context-select/company-context.reducer';

const ACCESS_TOKEN = 'access_token';
const REFRESH_TOKEN = 'refresh_token';
const EVIDENCE_CREDENTIALS = 'evidence_credentials';
const COMPANY_CONTEXT = 'company_context';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  getToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN);
  }

  saveToken(token: string): void {
    localStorage.setItem(ACCESS_TOKEN, token);
  }

  saveRefreshToken(refreshToken: string): void {
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
  }

  removeToken(): void {
    localStorage.removeItem(ACCESS_TOKEN);
  }

  removeRefreshToken(): void {
    localStorage.removeItem(REFRESH_TOKEN);
  }

  removeCompanyContext(): void {
    localStorage.removeItem(COMPANY_CONTEXT);
    // Also remove NgRx persisted state
    localStorage.removeItem('companyContext');
  }

  saveEvidenceCredentials(credentials: EvidenceCredentials): void {
    localStorage.setItem(EVIDENCE_CREDENTIALS, JSON.stringify(credentials));
  }

  getEvidenceCredentials(): EvidenceCredentials | null {
    const raw = localStorage.getItem(EVIDENCE_CREDENTIALS);
    if (!raw) {return null;}

    try {
      return JSON.parse(raw) as EvidenceCredentials;
    } catch (e) {
      console.error('Failed to parse evidence credentials:', e);
      return null;
    }
  }

  /**
   * @deprecated Use NgRx Store with selectSelectedCompany, selectSelectedCompanyUnit, selectSelectedRole selectors instead.
   * This method directly reads from localStorage which is less efficient and not reactive.
   * For new code, inject Store and use the company-context selectors.
   */
  getCompanyContext(): CompanyContext | null {
    const raw = localStorage.getItem('companyContext');
    if (!raw) {return null;}

    try {
      const state = (JSON.parse(raw) as { companyContext: CompanyContextState })?.companyContext;

      const companyContext = new CompanyContext(
        '',
        state?.selectedCompany?.credentialsId ?? '',
        state?.selectedCompanyUnit?.bdoId ?? '',
        state?.selectedRole?.value ?? null,
        4
      );

      return companyContext;
    } catch (e) {
      console.error('Failed to parse company context:', e);
      return null;
    }
  }

  saveCompanyContext(companyContext: CompanyContext): void {
    localStorage.setItem(COMPANY_CONTEXT, JSON.stringify(companyContext));
  }
}
